import { ChangeDetectorRef, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {SelectionModel} from '@angular/cdk/collections';
import { MatSort, Sort } from '@angular/material/sort';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { FormsService } from '../../services/forms.service';
import * as jwt_decode from 'jwt-decode';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { ConfirmDialogModel, ConfirmDialogComponent } from '../../../../middleware/common/reusableComponents/confirm-dialog/confirm-dialog.component';
import { ProjectTempType, RoleLevel } from '../../services/form.enum';

@Component({
  selector: 'app-trash',
  templateUrl: './trash.component.html',
  styleUrls: ['./trash.component.scss']
})

export class TrashComponent implements OnInit {

  databaseId: string;
  organizationId: string;
  currentUser: any;
  trashProjectsList: any[] = [];  
  displayedColumns: string[] = [];
  dataSource: any;
  selection = new SelectionModel<any>(true, []);
  _returnList: any[] = [];
  _returnColumns: any[] = [];
  Module:string;
  pageSizeOptions: number[] = [10, 20, 50, 100];
  paginatorTotalLength:any;
  pageModelData = {
    pageIndex: 0,
    pageSize: 10,
    searchValue: '',
  };  
  SelectedRecordForDeleFav:boolean=false;
  selectedRecordDeleteArray: any = [];
  noRecordFound:boolean = false;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  docDetail:boolean = false;
  groupDetail:boolean = false;
  showmyDrive:boolean = false;
  value = '';
  pageIndex: any;
  pageSize: any;
  ParticipantList:any=[];
  rolesAsssign: any[] = [];
  ShowMasterTemplate:boolean=false;
  OfficeIDList: any = [];
  myOfficeID: any;
  constructor(private router: Router,private dialog: MatDialog,private formsService:FormsService,
    private reusableClass:ReusableClasses,private encryptionAlgo: EncryptionService,
    private _dataSharingService: DataSharingService, private cdr: ChangeDetectorRef,
    private loaderService: LoaderService) {
      const encryptedtoken = sessionStorage.getItem('userToken');
      const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
      this.databaseId = sessionStorage.getItem('databaseId');
      this.organizationId = sessionStorage.getItem('organizationID');
      this.currentUser = jwt_decode(token);
    var offices = JSON.parse(sessionStorage.getItem('officeList'));
    offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID)
      if (oe.isMyoffice == true)
        this.myOfficeID = oe.officeID;
    });
     }

  ngAfterContentChecked() {
    this.cdr.detectChanges();
   }

  ngOnInit(): void {
    sessionStorage.setItem('edashboard', "false");
    this.paginatorTotalLength=0;
    this.getTrashBoxItems(this.pageModelData);
    this.setDisplayedColumns();   
   
    this.rolesAsssign = JSON.parse(sessionStorage.getItem("roles"));
    if(this.rolesAsssign.length > 0){
      var role=[];
      // roleLevel:1(Super admin), roleLevel:2(Organization Admin), roleLevel:3(Office Admin),roleLevel:11(User)
      role= this.rolesAsssign.filter((m) => m.roleLevel == RoleLevel.SuperAdmin);
      if(role.length > 0){
       this.ShowMasterTemplate = true;
      }else{
        this.ShowMasterTemplate = false;
      }
    }
  }

  CreatePdfForm(Option){
    // True-Create PDF Form
    // False-Create Master Template PDF Form
    if(Option==false){
      sessionStorage.setItem('MasterTemplatePDFForm','true');
      sessionStorage.setItem('type',(ProjectTempType.Template).toString());
    }else{
      sessionStorage.setItem('MasterTemplatePDFForm','false');
      sessionStorage.setItem('type',(ProjectTempType.Project).toString());
    }
    sessionStorage.removeItem("ProjectName");
    sessionStorage.removeItem("projectID");    
    sessionStorage.setItem('ImportTemplateShow','true');
    sessionStorage.setItem('MasterOrgTemplatePDFForm','false');
    sessionStorage.removeItem('stepCompleted');
    sessionStorage.setItem('FolderOpenId','0');
    sessionStorage.setItem('FolderOpenName',''); 
    this._dataSharingService.sendSelectedProjectName("");
    this.router.navigate(['/esignature/first']);
  }
  
  CreateHTMLForm(Option){    
    if(Option==false){
      sessionStorage.setItem('MasterGlobalTemplateWebForm','true');
      sessionStorage.setItem('MasterOrgTemplateWebForm','false');     
    }else{
      sessionStorage.setItem('MasterTemplateWebForm','true');
      sessionStorage.setItem('MasterOrgTemplateWebForm','false');
    }
    sessionStorage.removeItem("ProjectName");
    sessionStorage.removeItem("projectID");   
    sessionStorage.setItem('ImportTemplateShow','true');
    sessionStorage.removeItem('stepCompleted');
    sessionStorage.removeItem('categoryID');
    sessionStorage.setItem('FolderOpenId','0');
    sessionStorage.setItem('FolderOpenName','');   
    this._dataSharingService.sendSelectedProjectName("");
    this._dataSharingService.sendSelectedModuleName('Forms');
    sessionStorage.setItem('isSharedWithMeForm','false');
    this.router.navigate(['/esignature/htmlform']);
  }
  
  CreateAuditForm(Option){
    // True-Create Tabular Form
    // False-Create Master Template Tabular Form
    if(Option==false){
      sessionStorage.setItem('MasterTemplateTabularForm','true');
    }else{
      sessionStorage.setItem('MasterTemplateTabularForm','false');
    }
    sessionStorage.removeItem("ProjectName");
    sessionStorage.removeItem("projectID");
    sessionStorage.setItem('type',(ProjectTempType.Template).toString());
    sessionStorage.setItem('ImportTemplateShow','true');
    sessionStorage.removeItem('stepCompleted');
    sessionStorage.setItem('FolderOpenId','0');
    sessionStorage.setItem('FolderOpenName','');   
    this._dataSharingService.sendSelectedProjectName("");
    sessionStorage.setItem('isSharedWithMeForm','false');
    this.router.navigate(['/esignature/firsttabular']);
  }
  
  getTrashBoxItems(pageData: any) {
    this.pageIndex = pageData.pageIndex;
    this.pageSize = pageData.pageSize;
    var ReqModel = {
      pageIndex:this.pageModelData.pageIndex,
      pageSize:this.pageModelData.pageSize,
      searchKey:this.pageModelData.searchValue,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      OfficeID:this.myOfficeID,
      databaseID: Number(this.databaseId),
    }
    this.loaderService.show();    
    this.formsService.GetTrashBoxItems(ReqModel).subscribe(response=>{
     if(response.data!=null){
       this.dataSource = new MatTableDataSource<any>();
       this.trashProjectsList = response.data.sentOrInboxListModelList;
       this.dataSource.data =this.trashProjectsList;
       this.dataSource.sort = this.sort;   
       this.paginatorTotalLength = response.data.totalcount;
       this.pageModelData.pageIndex = response.data.pageIndex;
       this.pageIndex = response.data.pageIndex;
       this.pageSize = pageData.pageSize;
       if(this.trashProjectsList.length >0){
        this.noRecordFound=false;
      }else{
       this.noRecordFound=true;
       this.SelectedRecordForDeleFav=false;
       this.selection.clear();
      }
      this.loaderService.hide();
     }else{
      this.paginatorTotalLength=0;
      this.loaderService.hide();
    }
    });
  
  }

  setDisplayedColumns() {
    this.displayedColumns  = ['projectId','subject','trashedDate','action'];
  }

  SearchFilter() { 
    this.selection.clear(); 
    this.SelectedRecordForDeleFav=false;
    this.pageModelData.pageIndex=0;
    this.pageModelData.searchValue; 
    if(this.pageModelData.searchValue==""){
      return;
     }
    // this.getTrashBoxItems(this.pageModelData);
  }

  Search(filterValue) {
    this.selection.clear(); 
    this.SelectedRecordForDeleFav=false;
    this.pageModelData.pageIndex=0;
    this.pageModelData.searchValue=filterValue.trim();
    // this.getTrashBoxItems(this.pageModelData);
  }

  pageEventPropogate(pageData: PageEvent) {     
    this.pageModelData.pageIndex = pageData.pageIndex;
    this.pageModelData.pageSize = pageData.pageSize;
    this.pageModelData.searchValue;
    this.getTrashBoxItems(this.pageModelData);       
  }

 /** Whether the number of selected elements matches the total number of rows. */
 isAllSelected() {
  const numSelected = this.selection.selected.length;
  const numRows = this.dataSource.data.length;
  return numSelected === numRows;
}

/** Selects all rows if they are not all selected; otherwise clear selection. */
masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.data.forEach(row => {
        this.selection.select(row)});
        this.selectedRecordDeleteArray=[];    
        if (this.selection.selected.length > 0) {
          for (let i = 0; i < this.selection.selected.length; i++) {          
              let ReqModel = {
                selectedRecord: this.selection.selected[i].projectInboxSentId
                };
               this.selectedRecordDeleteArray.push(ReqModel);    
          }
          this.SelectedRecordForDeleFav = true;
        }
        else {
          this.SelectedRecordForDeleFav = false;
          this.selectedRecordDeleteArray = [];
        }     
}

   isAllSelectedRow(event, element) {
    let ReqModel = {
      selectedRecord: element.projectInboxSentId
    };
    if (event.checked) {
      this.selectedRecordDeleteArray.push(ReqModel);
    } else {
      let removeIndex = this.selectedRecordDeleteArray.findIndex(
        (itm) => itm.selectedRecord === element.projectInboxSentId
      );
      if (removeIndex !== -1) this.selectedRecordDeleteArray.splice(removeIndex, 1);
    }
    if (this.selectedRecordDeleteArray.length > 0) {
      this.SelectedRecordForDeleFav = true;
    }
    else {
      this.SelectedRecordForDeleFav = false;
      this.selectedRecordDeleteArray = [];
    } 
   }

   deleteSentProjects(){
    const message = `Are you sure you want to delete selected record?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
  
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {
          let selectedProjectIds=[];
          this.selectedRecordDeleteArray.forEach(element => {            
            selectedProjectIds.push(element.selectedRecord);
          });
          let rqModel = {
            projectInboxSentId: selectedProjectIds,
            userID: this.currentUser.UID,
            organizationID: Number(this.organizationId),
            databaseID: Number(this.databaseId),
          }
          this.formsService.DeleteInboxSentProjects(rqModel).subscribe(response=>{
            if(response.data==true){
              this.SelectedRecordForDeleFav = false;
              this.pageModelData.searchValue="";
              this.getTrashBoxItems(this.pageModelData);
            }
          })
          this.SelectedRecordForDeleFav = false;
          this.selectedRecordDeleteArray = [];
          this.selection.selected.forEach(item => {
            let index: number = this.dataSource.data.findIndex(d => d === item);  
            this.dataSource.data.splice(index, 1)
            this.dataSource = new MatTableDataSource<Element>(this.dataSource.data);
          });
          this.selection = new SelectionModel<Element>(true, []);
        }
        else{
          this.selectedRecordDeleteArray=[];
        }
      } catch (e) {
        //Observable.throw(e);
      }
    });
  }
  
  movetoTrash(projectInboxSentId){
      this.selectedRecordDeleteArray=[];
      this.selectedRecordDeleteArray.push({selectedRecord:projectInboxSentId});
      const message = `Are you sure you want to move this record to trash?`;
      const title = `Confirm Move`;
      const confirm = `Move`;
      const dialogData = new ConfirmDialogModel(title, message,confirm);     
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        panelClass: 'edituserdetails',
        maxWidth: '1000px',
        maxHeight: '500px',
        data: dialogData,
      });
    
      dialogRef.beforeClosed().subscribe(async (dialogResult) => {
        try {
          if (dialogResult) {
            let selectedProjectIds=[];
            this.selectedRecordDeleteArray.forEach(element => {              
              selectedProjectIds.push(element.selectedRecord);
            });
            let rqModel = {
              projectInboxSentId: selectedProjectIds,
              userID: this.currentUser.UID,
              organizationID: Number(this.organizationId),
              databaseID: Number(this.databaseId),
            }
            this.formsService.MoveSentProjectsToTrash(rqModel).subscribe(response=>{
              if(response.data==true){
                this.SelectedRecordForDeleFav = false;
                this.pageModelData.searchValue="";
                this.getTrashBoxItems(this.pageModelData);
              }
            })
            this.SelectedRecordForDeleFav = false;
            this.selectedRecordDeleteArray = [];
            this.selection.selected.forEach(item => {
              let index: number = this.dataSource.data.findIndex(d => d === item);  
              this.dataSource.data.splice(index, 1)
              this.dataSource = new MatTableDataSource<Element>(this.dataSource.data);
            });
            this.selection = new SelectionModel<Element>(true, []);
          }
          else{
            this.selectedRecordDeleteArray=[];
          }
        } catch (e) {
          //Observable.throw(e);
        }
      });
    }
  

  showDocDetail(){
    this.docDetail = !this.docDetail
  }
  
  showMyDrive(){
    this.showmyDrive = !this.showmyDrive
  }

  close() {
    this.ParticipantList=[];
    this.dialog.closeAll();
  }

  
  

}
